import NumberFormat from 'react-number-format';
import { FaTrash } from "react-icons/fa";
import Hover from './hovercomponent';
import _ from 'lodash';

const Product = ({ smartShipCheck, is_autoship, minCartAutoshipCheck, Cart, deleteproduct, index, register, Add, Sub, updateqty, setcosttype, costtype, swithtoautoship }) => {
  //check product is selected to autoship or normal
  const qty = +Cart?.quantity || 1;
  const isAutoshipItem = !!Cart?.is_autoship;
  const isSmartShipPrice = minCartAutoshipCheck === "True" || smartShipCheck === true || isAutoshipItem;
  const displayCostPrice = isAutoshipItem || isSmartShipPrice
    ? Cart?.product?.autoship_cost_price
    : Cart?.product?.cost_price;
  const hasPromotion = Cart?.applied_promotion != null;
  const promotionalAutoshipPrice = Cart?.product?.promotional_autoship_price;
  const hasAutoshipPromotion = promotionalAutoshipPrice != null && promotionalAutoshipPrice !== "";
  const promoPrice = Cart?.line_total != null ? Cart.line_total : (Cart?.unit_price * qty);
  const originalPrice = Cart?.original_line_total != null
    ? Cart.original_line_total
    : (Cart?.original_unit_price != null ? Cart.original_unit_price * qty : displayCostPrice * qty);
  const formatPrice = (amount) => `$${parseFloat(amount).toFixed(2)} USD`;

  function _setAutoshipFunction(event, id, orderId) {

    swithtoautoship(event, orderId);
  }

  return (
    <>
      <tr key={index}>
        <td>
          <div className="cart-image">
            {Cart?.product?.main_image
              ?
              <img src={`${process.env.API_URL}${Cart?.product.main_image}`} />
              :
              <img src="/images/no-image.jpg" />
            }
          </div>
        </td>
        <td>
          {(Cart?.extraProduct || Cart?.promo_fake_product) &&
            <div className='free_product_title'>
              <p style={{
                color: "#f00",
                fontFamily: 'Graphik-bold',
                margin: 0
              }}>Your Free Product!</p>
            </div>
          }
          <div className="cart-product-details">
            {Cart?.product?.name}
          </div>
        </td>
        {(!Cart?.extraProduct && !Cart?.promo_fake_product) ?
          <>
            <td>
              <div className="">
                {["Product", "Bundle"].includes(Cart?.product?.product_type) &&
                  <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example"
                    data-product-id={Cart?.product?.id}
                    data-product-qty={Cart?.quantity}
                    data-variant-id={null}

                    onChange={(e) => _setAutoshipFunction(e, Cart?.product?.id, Cart?.id)}
                    value={_.find(costtype, { orderId: Cart?.id })?.autoship}
                  >
                    <option value="Normal">One-time Only</option>
                    <option value="AutoShip">SmartShip</option>
                    {/* <option value="AutoShip" selected={is_autoship==='True'?true:false} >AutoShip</option> */}
                  </select>
                }
              </div>
            </td>
            <td>
              <div className="main-qty-sec">
                <div className="box">
                  {(Cart?.qty_display) ?
                    <div id="qty">
                      <button type="button" name={`${Cart?.product?.id},${null}`} id={Cart?.product?.id} className="sub" value={Cart?.quantity} onClick={(e) => { Sub(e, Cart?.id) }}>-</button>
                      <input
                        name={`${Cart?.product?.id},${null}`}
                        type="text"
                        ref={register &&
                          register({
                            valueAsNumber: true,
                          })
                        }
                        value={+Cart?.quantity}
                      />
                      <button type="button" name={`${Cart?.product?.id},${null}`} id={Cart?.product?.id}
                        data-value={Cart?.product?.quantity}
                        className="add"
                        value={Cart?.quantity}
                        onClick={(e) => { Add(e, Cart?.id) }}>+</button>
                    </div>
                    :
                    <div id="qty">
                      <button type="button" name={`${Cart?.product?.id},${null}`} id={Cart?.product?.id} className="sub">-</button>
                      <input
                        name={`${Cart?.product?.id},${null}`}
                        type="text"
                        readOnly={true}
                        ref={register &&
                          register({
                            valueAsNumber: true,
                          })
                        }
                        value={+Cart?.quantity}
                      />
                      <button type="button" name={`${Cart?.product?.id},${null}`} id={Cart?.product?.id} data-value={Cart?.product?.quantity} className="add">+</button>
                    </div>
                  }
                </div>
              </div>
            </td>
          </>
          :
          <>
            <td></td>
            <td>
              <div className="main-qty-sec">
                <div style={{
                  width: "100%",
                  maxWidth: "112px",
                  textAlign: "center",
                }}>
                  <input
                    name={`${Cart?.product?.id},${null}`}
                    type="text"
                    style={{
                      width: "40px",
                      background: "#fff",
                      border: "1px solid var(--blue)",
                      textAlign: "center",
                      padding: "7.5px"
                    }}
                    readOnly
                    value={+Cart?.quantity}
                  />
                </div>
              </div>
            </td></>
        }
        <td>
          <div className="cart-product-details">
            <div className="title">
              {isAutoshipItem && hasAutoshipPromotion ? (
                <div>
                  <div className="price-afterdiscount">
                    {formatPrice(promotionalAutoshipPrice * qty)}
                  </div>
                  <div className="price-beforediscount">
                    {formatPrice(Cart?.product?.autoship_cost_price * qty)}
                  </div>
                </div>
              ) : hasPromotion && !isAutoshipItem ? (
                <div>
                  <div className="price-afterdiscount">
                    {formatPrice(promoPrice)}
                  </div>
                  <div className="price-beforediscount">
                    {formatPrice(originalPrice)}
                  </div>
                </div>
              ) : (
                <NumberFormat value={parseFloat(displayCostPrice * qty).toFixed(2)}
                  displayType={'text'}
                  thousandSeparator={true} prefix={'$'}
                  renderText={value => <div>{value + " USD"}</div>}
                />
              )}
            </div>
            {Cart?.is_autoship ?
              <div className="title">
                <Hover data="Ships now & after 28 days" />
              </div>
              :
              <div className="title">
                <Hover data="SmartShip is deactivated" />
              </div>
            }
          </div>
        </td>
        <td>
          <div className="pro-cart-table">
            <div className="cart-product-qty-del">
              {(!Cart?.extraProduct && !Cart?.promo_fake_product) &&
                <button className="dlt" ><FaTrash onClick={(e) => { deleteproduct(Cart?.product?.id, Cart?.variant?.id, Cart?.id, Cart?.is_autoship) }} /></button>
              }
            </div>
          </div>
        </td>
      </tr>

    </>)
}
export default Product;